import React, { useCallback, useState } from 'react'
import ContractedHamburguerMenu from './ContractedHamburguerMenu'
import ExpandedMenu from './ExpandedHamburguerMenu'
import { SubscribeModal } from '../SubscribeModal/SubscribeModal'

const MobileMenu = () => {
  const [ showSubscribeModal, setShowSubscribeModal ] = useState( false )
  const [ expandMenu, setExpandMenu ] = useState( false )

  const toggleMenu = useCallback( () => {
    setExpandMenu( !expandMenu )
  }, [ expandMenu ] )

  return (
    <>
      <ContractedHamburguerMenu
        onClickHamburgerMenu={ toggleMenu }
        setShowSubscribeModal={ setShowSubscribeModal }
      />
      { expandMenu &&
        <ExpandedMenu
          onClickCloseButton={ toggleMenu }
          setShowSubscribeModal={ setShowSubscribeModal }
        /> }
      <SubscribeModal
        shouldDisplay={ showSubscribeModal }
        setShouldDisplay={ setShowSubscribeModal }
      />
    </>
  )
}

export default MobileMenu
